import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";

interface ITicketHistoryMessageModalProps {
  message: string;
  onClose: () => void;
}

const translationPath = "chatBot.page.logs.ticketHistories.";

const TicketHistoryMessageModal: React.FC<ITicketHistoryMessageModalProps> = ({
  message,
  onClose,
}) => {
  const { t } = useTranslation();
  const translate = (key: string, defaultValue: string) =>
    String(t(key, { defaultValue }));

  return (
    <Dialog open onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {translate(translationPath + "full_message_title", "Mensagem completa")}
      </DialogTitle>
      <DialogContent>
        <Typography
          component="pre"
          sx={{
            margin: 0,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            fontFamily: "inherit",
          }}
        >
          {message}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          {translate(translationPath + "close", "Fechar")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default memo(TicketHistoryMessageModal);
